import type { PlainDate } from "@sa-nu/shared-utils/date";

import type { DatePickerSelection } from "./get-next-selection";

// maxNights 未指定は単一日選択モードで CO の概念が無いため、ツールチップを出さない。
export function deriveCheckoutTooltipDate(params: {
  selection: DatePickerSelection;
  maxNights: number | undefined;
}): PlainDate | null {
  const { selection, maxNights } = params;
  if (maxNights === undefined) return null;

  const { startDate, endDate } = selection;
  if (startDate === null || endDate !== null) return null;

  return startDate.add({ days: 1 });
}
